<template>
  <div>
    <div class="dashboard-page-title">
      <div class="container-fluid">
        <h1>Add {{ $starLabel | sentenceCase }}</h1>
      </div>
    </div>

    <div class="container-fluid">
      <div class="dashboard-block">
        <form>
          <div class="panel panel-grey">
            <div class="panel-body">
              <div class="form-horizontal">

                <create-user ref="createUser"/>

                <div class="row">
                  <div class="col-md-12 col-lg-6" v-if="this.gender_module_enabled">
                    <div class="form-group" :class="{ 'has-error' : $v.gender.$error }">
                      <label class="control-label col-sm-4">* Gender:</label>
                      <div class="col-sm-8">
                        <div class="radio radio-inline radio-primary checkbox-filter-gender">
                          <input
                            type="radio"
                            name="profile.gender"
                            id="gender_male"
                            value="male"
                            v-model="$v.gender.$model"
                            >
                          <label for="gender_male">
                            <i class="fa fa-male"></i>
                          </label>
                        </div>
                        <div class="radio radio-inline radio-primary checkbox-filter-gender">
                          <input
                            type="radio"
                            name="profile.gender"
                            id="gender_female"
                            value="female"
                            v-model="$v.gender.$model">
                          <label for="gender_female">
                            <i class="fa fa-female"></i>
                          </label>
                        </div>
                        <div class="radio radio-inline radio-primary checkbox-filter-gender">
                          <input
                            type="radio"
                            name="profile.gender"
                            id="gender_other"
                            value="other"
                            v-model="$v.gender.$model">
                          <label style="font-size: 16px; line-height: 26px;" for="gender_other">
                            Other
                          </label>
                        </div>

                        <div class="help-block" v-if="$v.gender.$error" >
                          <span v-if="!$v.gender.required" >Gender is required</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-12 col-lg-6" v-if="this.talent_dob_module_enabled" >
                    <div class="form-group" :class="{ 'has-error' : $v.date_of_birth.$error }">
                      <label class="control-label col-sm-4">* Date of Birth:</label>
                      <div class="col-sm-8">

                        <flat-pickr
                          :config="datePickerConfig"
                          class="form-control pickdate"
                          placeholder="Please select a date"
                          name="date_of_birth"
                          v-model="$v.date_of_birth.$model"
                        />

                        <div class="help-block" v-if="$v.date_of_birth.$error" >
                          <span v-if="!$v.date_of_birth.required" >Date of birth is required</span>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>

              </div>
            </div>
            <div class="panel-footer">
              <ladda-button
                class="btn btn-sm btn-primary"
                type="submit"
                :click="handleAddTalentCallback">
                Add {{ $starLabel | sentenceCase }}
              </ladda-button>

              <div class="checkbox checkbox-primary pull-right" v-if="$vlastMode && $userIsAdmin">
                <input
                  type="checkbox"
                  name="send_activation_email"
                  id="send_activation_email"
                  v-model="$v.send_activation_email.$model"
                  />

                <label for="send_activation_email">
                  Send Activation Email To {{ $starLabel }}
                </label>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { notify, http } from 'utils'
import { VueTelInput } from 'vue-tel-input'
import FlatPickr from 'vue-flatpickr-component'
import { requiredIf } from 'vuelidate/lib/validators'
import CreateUser from '../CreateUser'
import { stateMapper, helpers } from 'mixins/users'

export default {
  mixins: [stateMapper, helpers],
  components: {
    CreateUser,
    VueTelInput,
    FlatPickr
  },

  data () {
    return {
      gender: null,
      date_of_birth: null,
      send_activation_email: false,
      gender_module_enabled: false,
      talent_dob_module_enabled: false,
    }
  },

  validations: {
    gender: {
      required: requiredIf(function () { return this.gender_module_enabled })
    },
    date_of_birth: {
      required: requiredIf(function () { this.$talent_dob_module_enabled })
    },
    send_activation_email: {}
  },

  computed: {
    datePickerConfig () {
      return {
        altInput: true,
        altFormat: 'd/m/Y',
        dateFormat: 'Y-m-d',
        maxDate: new Date()
      }
    }

  },
  mounted () {
    this.talent_dob_module_enabled = this.$talentDateOfBirthEnabled
    this.gender_module_enabled = this.$genderModuleEnabled
  },
  methods: {
    handleAddTalentCallback () {
      if (this.$refs.createUser.invalid || this.$v.$invalid) {
        this.$v.$touch()
        this.$refs.createUser.validate()
        notify.error('Some fields are invalid. Please check and try again.')
        return Promise.resolve()
      }

      const payload = {
        ...this.$refs.createUser.payload,
        profile: {
          gender: this.gender
        },
        date_of_birth: this.date_of_birth,
        send_activation_email: this.send_activation_email,
        self_verified: false
      }
      if (this.$route.query.managerId) {
        payload.manager_id = this.$route.query.managerId
      }

      return http.post(`talent`, payload)
        .then((response) => {
          this.$router.push({ name: 'talent.profile.show', params: { id: response.data.id } })
        })
        .catch(() => {
          notify.error('Something went wrong. Please check your input and try again.')
        })
    }
  }
}
</script>
